export default value => (!!value || value === 0)
